export default "__VITE_ASSET__f5cd75bd__"